import { Dispatch } from 'react';
import { createRemoveFavorites } from '../../../api';
import { messageInfo } from '../../../components/message';
import getFormatMessage from '../../../locales/get-format-message';
import {
  GamesAction,
  getGameFavoriteTotalAction,
  getServiceMyFavoriteListAction,
} from '../../../store/modules/games';
import { formatGameParamsByLocationPathname } from './game-url-format';

export const createServiceFavorites = async (
  dispatch: Dispatch<GamesAction>,
  id: number,
  status: number
) => {
  const data = formatGameParamsByLocationPathname(location.pathname);
  const res = await createRemoveFavorites({
    ServiceID: id,
    Status: status,
    GameID: data.gameId,
  });
  if (res) {
    if (status === 0) {
      messageInfo(getFormatMessage('remove_favorites_success'));
    } else if (status === 1) {
      messageInfo(getFormatMessage('add_favorites_success'));
    }
    getServiceMyFavoriteListAction(dispatch as any, data.gameId)();
    getGameFavoriteTotalAction(dispatch as any)();
  }
};
